var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPadLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  d: "M19.93 11.06c0-.632-.518-1.15-1.15-1.15H5.15c-.633 0-1.15.518-1.15 1.15v9.79c0 .633.517 1.15 1.15 1.15h13.63c.632 0 1.15-.517 1.15-1.15v-9.79Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.075 15.462a2.049 2.049 0 1 0-2.22 0l-.352 2.407a.334.334 0 0 0 .34.393h2.244a.334.334 0 0 0 .34-.393l-.352-2.407Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8B24F",
  d: "M17.001 9.91h-2.07V7.037a2.97 2.97 0 0 0-2.966-2.966 2.97 2.97 0 0 0-2.967 2.966v2.875h-2.07V7.036A5.042 5.042 0 0 1 11.965 2 5.042 5.042 0 0 1 17 7.036v2.875Z"
})));
export default SvgPadLock;